import { UserPanel } from './UserPanel';
import { AuthContextProps, useAuth } from 'oidc-react';
import { Button } from '@mui/material';
import { authSettings } from '../api/OidcSettings';
import { useTranslation } from 'react-i18next';
import { AppDispatch } from '../store';
import { useDispatch } from 'react-redux';
import { SessionStore } from '../services/SessionStore';
import { ESessionStore } from '../data/Constants';
import { Buffer } from 'buffer';
import { IsAppOpenedByExtApp } from '../services';
import { setAuthState } from '../store/states/ConfigurationSlice';

/**
 * Renders a button for login and logout functionality
 * @returns {JSX.Element} the user menu component
 */
export const HeaderLogin = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  let auth: AuthContextProps;

  if (authSettings.Developer_Mode) {
    return <Button color="secondary">{'LOCAL DEVELOPER'}</Button>;
  }

  let isLoggedin = false;
  let userName = '';
  if (IsAppOpenedByExtApp()) {
    isLoggedin = true;
    const uname = Buffer.from(SessionStore.get(ESessionStore.Token).split('.')[1], 'base64');
    userName = JSON.parse(decodeURIComponent(uname.toString())).name;
  } else {
    auth = useAuth(); //Do not move this line outside of this function, as it will cause an error for Hybris scenario
    isLoggedin = !!auth?.userData;
    userName = `${auth.userData?.profile.name}`;
  }

  return isLoggedin ? (
    <UserPanel user={userName} />
  ) : (
    <Button
      color="secondary"
      onClick={() => {
        dispatch(setAuthState({ authState: 'login' }));
        auth.signIn();
      }}
    >
      {t('button.login')}
    </Button>
  );
};
